import { Environment } from '@socium/sociumflow';
export const environment = {
  production: false,
  env: Environment.DEV,
  refreshInterval: 20 * 60 * 1000, // 20 minutes
  tokenBufferTime: 25 * 60 * 1000, // 25 minutes
  accessibleCompaniesPollInterval: 2 * 60 * 1000, // 2 minutes
  workSpaceEndpoint: 'https://workspace-api.dev.socium-hr.com/api',
  workspaceUrl: 'https://workspace.dev.socium-hr.com',
  jobUrl: 'https://job.dev.socium-hr.com',
  workflowUrl: 'https://workflow.dev.socium-hr.com',
  workflowEndpoint: 'https://workflows-api-dev.socium.link/api',
  perfUrl: 'https://perf.dev.socium-hr.com',
  docUrl: 'https://doc.dev.socium-hr.com',
  payrollUrl: 'https://payroll.dev.socium-hr.com',
  payrollEndpoint: 'https://payroll-api.dev.socium-hr.com/api',
  timeUrl: 'https://time.dev.socium-hr.com',
  apiUrl: 'https://doc-api.dev.socium-hr.com/api',
  allowedDomains: [
    'https://workspace.dev.socium-hr.com',
    'workspace.dev.socium-hr.com',
  ],
  apiKey: 'fzefzefk343432KDKFDSK34232',
  s3Url: 'https://s3.eu-west-2.amazonaws.com',
  bugsnagApiKey: 'c88b008bd9989d947e0ce994a54a070c',
  syncFusionLicense:
    'Ngo9BigBOggjHTQxAR8/V1NCaF5cXmpCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWXlcd3RTRGNdWUx+X0o=',
  wordConverterApiUrl:
    'https://doc-converter-service.dev.socium-hr.com/api/doc-converter/convert',
  syncFusionPdfResource:
    'https://cdn.syncfusion.com/ej2/23.1.43/dist/ej2-pdfviewer-lib',
  converterApiKey: 'd41d8cd98f00b204e9800998ecf8427e',
  webSocketUrl: 'wss://doc-api.dev.socium-hr.com/api-notifications',
  appName: 'socium-doc-management',
  envName: 'development',
  url: 'https://doc.dev.socium-hr.com',
  bugsnagEnabled: false,
  intercomAppId: 'nylak2wj',
  showIntercom: false,
  datadog_appId: '93574582-17bb-4fc1-8666-38170dae38e6',
  datadog_clientToken: 'pubd2c4782bd5fd24f64b12df961a54c64f',
};
